import React from 'react';
import PropTypes from 'prop-types';
import { VdpPopoverItem } from 'site-modules/shared/components/inventory/vdp-popover-item/vdp-popover-item';

function getCitySectionText(cityMPG, highwayMPG, summaryItemName) {
  if (cityMPG && highwayMPG) {
    return `${cityMPG}/${highwayMPG} City/Hwy ${summaryItemName}`;
  }

  if (cityMPG) {
    return `${cityMPG} City ${summaryItemName}`;
  }

  return `${highwayMPG} Hwy ${summaryItemName}`;
}

export function VehicleSummaryMpgContent({
  cityMPG,
  combinedMPG,
  highwayMPG,
  combinedSectionTooltipText = '',
  citySectionTooltipText = '',
  summaryItemName,
}) {
  const renderTooltip = (text, name) => (
    <VdpPopoverItem
      placement="bottom"
      className="text-gray-darker"
      iconClassName="px-0_25 pt-0_5 pb-0 p-md-0"
      screenReaderTooltipLabel={name}
    >
      {text}
    </VdpPopoverItem>
  );

  return (
    <div className="text-gray-darker align-right">
      {(!!cityMPG || !!highwayMPG) && (
        <div>
          {getCitySectionText(cityMPG, highwayMPG, summaryItemName)}
          {!!citySectionTooltipText && renderTooltip(citySectionTooltipText, `city-${summaryItemName}`)}
        </div>
      )}
      {combinedMPG && (
        <div>
          {combinedMPG} Combined {summaryItemName}
          {!!combinedSectionTooltipText && renderTooltip(combinedSectionTooltipText, `combined-${summaryItemName}`)}
        </div>
      )}
    </div>
  );
}

VehicleSummaryMpgContent.propTypes = {
  summaryItemName: PropTypes.string.isRequired,
  cityMPG: PropTypes.number,
  highwayMPG: PropTypes.number,
  combinedMPG: PropTypes.number,
  combinedSectionTooltipText: PropTypes.string,
  citySectionTooltipText: PropTypes.string,
};
